import { Component, OnInit, Input, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { SearchFormService } from './search-form.service';
import { SearchObjectService, SearchObject } from '../../../../shared/services/search-object.service';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
//import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { switchMap } from 'rxjs/operators';
import { SearchOptionTypes, SpecialtyTypes } from 'src/app/shared/models/FIlterTerms';

export interface InnerSpecialtiesDataModel {
  name: string;
  isPopular: boolean;
  type: string;
  orderNumber: string;
}

export interface SpecialtiesDataModel {
  name: string;
  data: InnerSpecialtiesDataModel[];
}

@Component({
  selector: 'app-search-form',
  templateUrl: './search-form.component.html',
  styleUrls: ['./search-form.component.scss']
})
export class SearchformComponent implements OnInit, OnDestroy {
  @Input() searchObject: SearchObject;
  @Input() isLoginPage: boolean;
  @Input() isPCPSearch: boolean;
  @Input() providerName;
  @Input() providerPhoneNumber;
  @Input() providerErrorMsg;
  networkSub;
  specialtySub;
  autoCompleteSubscription;
  searchViaFilterSubscription;
  isOpenAutoComplete = false;
  // benefitYear = new Date().getFullYear();
  networkIDChange$: Subject<boolean> = new Subject<boolean>();
  specialtySub$: Subject<void> = new Subject();
  hidePopular = false;

  autoCompleteFormControl = new FormControl();
  specialtyOptions: SpecialtiesDataModel = {
    name: 'Autocomplete',
    data: []
  };
  popularSpecialties: SpecialtiesDataModel = {
    name: 'Popular',
    data: []
  };
  allSpecialties: SpecialtiesDataModel = {
    name: 'All',
    data: []
  };
  chkboxSpecialties = [];
  coverageTypeValue: string = undefined;
  coverageTypesData = [];
  coverageYearData = [2022, 2023];  // this year, next year
  notificationText = '';
  shouldDisplayPlanYearPicker = false;
  multiYearPlans = [];
  multiYearString = '';
  selectedMultiYearPlan;
  ddRadiusData = [
    { label : '1 mile or less', value : '1' },
    { label : '2 miles or less', value : '2' },
    { label : '5 miles or less', value : '5' },
    { label : '10 miles or less', value : '10' },
    { label : '20 miles or less', value : '20' },
    { label : '50 miles or less', value : '50' },
    { label : '100 miles or less', value : '100' },
    { label : '150 miles or less', value : '150' },
    { label : '250 miles or less', value : '250' }
  ];

  error: any = {
    coverageTypeMsg: '',
    zipCodeMsg: '',
    providerNameMsg: '',
    specialtyOptionsMsg: '',
    phoneNumberMsg: ''
  };
  countyData = {
    counties: [],
    index: '',
    url: '',
    label: 'Go to site'
  };

  @ViewChild(MatAutocompleteTrigger, { static: false }) specialtyInput: MatAutocompleteTrigger;
  @ViewChild('specialtyInput', { static: false }) specialtyInputElement: ElementRef;

  @ViewChild('topSearchForm', {static: true}) topSearchForm: ElementRef;
  @ViewChild('userInputName', {static: false}) userInputName: ElementRef;
  @ViewChild('userInputNumber', {static: false}) userInputNumber: ElementRef;
  @ViewChild('userInputSpecialty', {static: false}) userInputSpecialty: ElementRef;
  @ViewChild('address', {static: false}) address: ElementRef;
  @ViewChild('orchid-select-distance', {static: false}) radius: ElementRef;
  @ViewChild('pcpUserInput', {static: false}) pcpUserInput: ElementRef;
  @ViewChild('pcpAddress', {static: false}) pcpAddress: ElementRef;
  @ViewChild('orchid-select-pcpdistance', {static: false}) pcpRadius: ElementRef;
  constructor(
    private searchFormService: SearchFormService,
    private searchObjectService: SearchObjectService
    //private GAService: GoogleAnalyticsService
    ) {
    this.networkSub = this.networkIDChange$.subscribe(() => {
      this.getSpecialties();
    });

    this.specialtySub = this.specialtySub$
    .pipe(switchMap(() => this.searchFormService.getSpecialties(this.searchObject.networkId)))
    .subscribe(data => {
        this.updateSpecialties(data);
      },
      error => {
        this.error.specialtyOptionsMsg = 'Error loading values. Please try again.';
      }
    );

    this.autoCompleteSubscription = this.autoCompleteFormControl.valueChanges.subscribe(value => {
      this.specialtyOptions.data =  value ? this._filter(value) : this.allSpecialties.data.slice();
    });

    this.searchViaFilterSubscription = this.searchObjectService.searchViaFilters.subscribe(() => {
      this.resetSearchForm();
    });
  }

  ngOnInit() {
    this.resetSpecialtyProviderType();
  }

  ngOnDestroy() {
    if (this.networkSub) {
      this.networkSub.unsubscribe();
    }
    if (this.specialtySub) {
      this.specialtySub.unsubscribe();
    }
    if (this.autoCompleteSubscription) {
      this.autoCompleteSubscription.unsubscribe();
    }
    if (this.searchViaFilterSubscription) {
      this.searchViaFilterSubscription.unsubscribe();
    }
  }

  @Input()
  set coverageTypes(coverageTypes: any) {
    this.notificationText = '';
    this.shouldDisplayPlanYearPicker = false;
    if (!this.searchObject.userInput) {
      this.autoCompleteFormControl.setValue('');
    }
    if (this.searchObject.networkId) {
      this.coverageTypeValue = this.searchObject.networkId;
    } else {
      this.coverageTypeValue = undefined;
    }
    if (coverageTypes) {
      this.coverageTypesData = coverageTypes;
      if (this.searchObject.networkId && !this.searchObject.altDestinationUrl) {
        const _len = coverageTypes.length;
        for (let i = 0; i < _len; i++) {
          if (coverageTypes[i].networkId === this.searchObject.networkId) {
            if (coverageTypes[i].altDestinationUrl) {
              this.coverageTypeValue = this.searchObject.networkId;
              this.searchObject.altDestinationUrl = coverageTypes[i].altDestinationUrl;
            }
            break;
          }
        }
      }

      // Show/Hide Radius and edit azure address settings based on isServiceAreaSearch
      if (this.coverageTypesData) {
        const nID = this.searchObject.networkId;
        const selectedCoverageType = this.coverageTypesData.filter((e) => {
          return nID === e.networkId;
        });

        if (selectedCoverageType.length > 0) {
          this.searchObject.isServiceAreaSearch = selectedCoverageType[0].isServiceAreaSearch;
          this.searchObject.coverageType = selectedCoverageType[0].name;
          this.notificationText = selectedCoverageType[0].notificationText;
          this.shouldDisplayPlanYearPicker = selectedCoverageType[0].shouldDisplayPlanYearPicker;
          // check and change specialty dropdown or checkbox
          this.searchObject.isMultiSpecialtySearch = selectedCoverageType[0].isMultiSpecialtySearch;

          // set multiyearplan object if available for coverage type
          if (selectedCoverageType[0].shouldDisplayPlanYearPicker && selectedCoverageType[0].multiYearPlans && selectedCoverageType[0].multiYearPlans.length > 0 && this.searchObject.searchYear) {
            this.multiYearPlans = selectedCoverageType[0].multiYearPlans;
            this.selectedMultiYearPlan = this.multiYearPlans.filter(obj => this.searchObject.searchYear == obj.planYear)[0];
            this.checkMultiYearPlan();
          }
        }
      }

      // logged in member logic
      if (this.searchObject.memberObject.careTypes && this.searchObject.memberObject.careTypes.length > 0 && this.searchObject.memberObject.loggedIn && this.searchObject.networkId) {
        this.countyData.index = '';
        this.countyData.url = '';
        const tempSubKey = this.searchObject.filters.subProductKey;
        this.searchObject.filters.subProductKey = undefined;
        for (let i = 0; i < this.searchObject.memberObject.careTypes.length; i++) {
          if (this.searchObject.networkId === this.searchObject.memberObject.careTypes[i].networkId) {
            if (this.searchObject.memberObject.careTypes[i].notificationText) {
              this.notificationText = this.searchObject.memberObject.careTypes[i].notificationText;
            }
            if (this.searchObject.memberObject.careTypes[i].shouldDisplayPlanYearPicker) {
              this.shouldDisplayPlanYearPicker = this.searchObject.memberObject.careTypes[i].shouldDisplayPlanYearPicker;
              this.multiYearPlans = this.searchObject.memberObject.careTypes[i].multiYearPlans;
              if (this.searchObject.memberObject.careTypes[i].renewalDate) {
                let d =  new Date(this.searchObject.memberObject.careTypes[i].renewalDate);
                this.multiYearString = `${d.toLocaleString('default', { month: 'long' })} ${d.getDate()}, ${d.getFullYear()}`;
              }
              const checkSubKey = this.multiYearPlans.filter((e) => {
                return tempSubKey === e.subProductKey;
              });
              if (checkSubKey.length > 0) {
                this.selectedMultiYearPlan = checkSubKey[0];
                this.searchObject.filters.subProductKey = this.selectedMultiYearPlan.subProductKey;
                this.checkMultiYearPlan();
              }
            } else {
              this.shouldDisplayPlanYearPicker = false;
              this.searchObject.filters.subProductKey = this.searchObject.memberObject.careTypes[i].subProductKey;

              if (this.searchObject.altDestinationUrl && this.searchObject.memberObject.careTypes[i]['altDestinationUrl'] && this.searchObject.memberObject.careTypes[i]['externalNetworks']) {
                this.countyData.counties  = this.searchObject.memberObject.careTypes[i]['externalNetworks'];
                let j = 0;
                this.countyData.counties.forEach(e => {
                  e.label = `${e.county}, ${e.state}`;
                  e.value = j.toString();
                  j++;
                });
              }
            }
            break;
          }
        }
      }

      this.networkIDChange$.next(null);
    }
  }

  @Input()
  set clickedSearchCriteria(e) {
    if (e) {
      if (e === 'userInput') {
        if (this.isPCPSearch) {
          if (this.pcpUserInput) {
            this.elementScroll(this.pcpUserInput, true);
          } else {
            this.elementScroll(this.topSearchForm);
          }
        } else {
          if (this.searchObject.isMultiSpecialtySearch) {
            this.elementScroll(this.topSearchForm);
          } else {
            if (this.searchObject.searchOption === SearchOptionTypes.phoneNumber) {
              if (this.userInputNumber) {
                this.elementScroll(this.userInputNumber, true);
              } else {
                this.elementScroll(this.topSearchForm);
              }
            } else if (this.searchObject.searchOption === SearchOptionTypes.providerName) {
              if (this.userInputName) {
                this.elementScroll(this.userInputName, true);
              } else {
                this.elementScroll(this.topSearchForm);
              }
            } else if (this.searchObject.searchOption === SearchOptionTypes.specialty) {
              if (this.userInputSpecialty) {
                this.elementScroll(this.userInputSpecialty, true);
              } else {
                this.elementScroll(this.topSearchForm);
              }
            }
          }
        }

      } else if (e === 'radius') {
        if (this.isPCPSearch) {
          if (this.pcpRadius) {
            this.elementScroll(this.pcpRadius, true);
          } else {
            this.elementScroll(this.topSearchForm);
          }
        } else {
          if (this.radius) {
            this.elementScroll(this.radius, true);
          } else {
            this.elementScroll(this.topSearchForm);
          }
        }
      } else if (e === 'address') {
        if (this.isPCPSearch) {
          if (this.pcpAddress) {
            this.elementScroll(this.pcpAddress, true);
          } else {
            this.elementScroll(this.topSearchForm);
          }
        } else {
          if (this.address) {
            this.elementScroll(this.address, true);
          } else {
            this.elementScroll(this.topSearchForm);
          }
        }
      }

    }

  }

  // onChangeBenefitYear(event: Event) {
  //   this.searchObject.benefitYear = Number((event.target as HTMLTextAreaElement).value);
  //   this.selectedMultiYearPlan = this.multiYearPlans.filter(obj => this.searchObject.benefitYear == obj.planYear)[0];  
  //   this.searchObject.filters.subProductKey = this.selectedMultiYearPlan ? this.selectedMultiYearPlan.subProductKey : null
  // }

  elementScroll(e: ElementRef, focus?: boolean) {
    e.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    if (focus) {
      e.nativeElement.focus({preventScroll: true});
    }
  }

  ngModelChangeOfZipCode(event: any) {
  //  this.searchObject.address = event;
    this.changeZipCode();
  }

  onPlaceChange(event: any) {
    this.searchObject.placeObject = event;
    if (event.formatted_address) {
      this.searchObject.address = event.formatted_address;
    }
    if (event.geometry) {
      if (event.geometry.lat && event.geometry.lng) {
        this.searchObject.lat = event.geometry.lat;
        this.searchObject.long = event.geometry.lng;
      }
    } else {
      this.searchObject.lat = null;
      this.searchObject.long = null;
    }
    if (event.postal_code) {
      this.searchObject.zipCode = event.postal_code;
    } else {
      this.searchObject.zipCode = null;
    }
    if (event.county) {
      this.searchObject.county = event.county;
    } else {
      this.searchObject.county = null;
    }
    if (event.state) {
      this.searchObject.state = event.state;
    } else {
      this.searchObject.state = null;
    }

    this._formValidation('all');
  }

  resetSpecialtyProviderType() {
    this.hidePopular = false;
    if (this.searchObject.providerType) {
      this.autoCompleteFormControl.setValue(this.searchObject.providerType);
      this.searchObject.userInput = this.searchObject.providerType;
    } else if (this.searchObject.specialty) {
      this.autoCompleteFormControl.setValue(this.searchObject.specialty);
      this.searchObject.userInput = this.searchObject.specialty;
    } else {
      this.autoCompleteFormControl.setValue(this.searchObject.userInput);
    }
    this.specialtyOptions.data = this.allSpecialties.data.slice();
  }


  _formValidation(type: string): boolean {
    if (this.searchObject.searchOption && (type === 'coverageType' || type === 'all')) {
      this.error.coverageTypeMsg = !this.searchObject.networkId ? 'Select the option that best describes how you get your insurance in this required field.' : '';
    }
    if (this.searchObject.searchOption === SearchOptionTypes.providerName && (type === SearchOptionTypes.providerName || type === 'all')) {
      this.error.providerNameMsg = !this.searchObject.providerName ? 'Please enter a provider name.' : '';
    }

    if (this.searchObject.searchOption === SearchOptionTypes.specialty && (type === 'specialtyOptions' || type === 'all')) {
      this.error.specialtyOptionsMsg = '';
      if (!this.searchObject.userInput) {
        if (this.searchObject.isMultiSpecialtySearch) {
          this.error.specialtyOptionsMsg = 'Please choose a service from the checkboxes above.';
        } else {
          this.error.specialtyOptionsMsg = 'Please enter a provider type, specialty, service, or equipment.';
        }
      } else if (this.searchObject.userInput) {
        if (!this.searchObject.isMultiSpecialtySearch) {
          let isValidValue = false;
          isValidValue = this.allSpecialties.data.some(obj => obj.name.toLowerCase() === this.searchObject.userInput.toLowerCase());
          if (!isValidValue) {
            this.error.specialtyOptionsMsg = 'There is no provider type, specialty, service, or equipment that matches "' + this.searchObject.userInput + '". Please try a different word.';
          }
        }
      }
    }

    this.error.phoneNumberMsg = '';
    if (this.searchObject.searchOption === SearchOptionTypes.phoneNumber && (!this.searchObject.phoneNumber || this.searchObject.phoneNumber?.replace(/\D/g, '').length !== 10)) {
    this.error.phoneNumberMsg = 'Please enter a valid phone number.';
    }

    if (type === 'address' || type === 'all') {
      this.error.zipCodeMsg = '';

      if (this.searchObject.isServiceAreaSearch) {
        if (!this.searchObject.address || !this.searchObject.county || !this.searchObject.state) {
          this.error.zipCodeMsg = 'Please enter a valid home address';
        }
      } else {
        if (!this.searchObject.address) {
          this.error.zipCodeMsg = 'Please enter a valid address, city, or 5-digit ZIP code';
        }
      }
    }

    return this.searchObject.searchOption === SearchOptionTypes.phoneNumber ? (this.error.phoneNumberMsg || this.error.zipCodeMsg ? false : true) : this.searchObject.searchOption === SearchOptionTypes.providerName ? this.error.coverageTypeMsg || this.error.providerNameMsg || this.error.zipCodeMsg ? false : true : this.error.coverageTypeMsg || this.error.specialtyOptionsMsg || this.error.zipCodeMsg ? false : true;
  }

  updateCounty(event) {
    const index = event.target.value;
    this.countyData.url = index === '' ? '' : this.countyData.counties[index].url;
  }

  updateCoverageType(event) {
    this.hidePopular = false;
    this.searchObject.isServiceAreaSearch = false;
    this.searchObject.networkId = undefined;
    this.searchObject.altDestinationUrl = undefined;
    this.searchObject.searchYear = undefined;
    this.multiYearPlans = [];
    this.multiYearString = '';
    this.selectedMultiYearPlan = undefined;
    this.error.coverageTypeMsg = '';
    this.specialtyOptions = {
      name: 'Autocomplete',
      data: []
    };
    this.chkboxSpecialties = [];
    this.countyData.counties = [];
    this.countyData.index = '';
    this.countyData.url = '';
    this.resetSpecialtyProviderType();
    if (event.target.value) {
      const coverageType = this.coverageTypesData.filter(e => e.networkId === event.target.value);
      if (coverageType.length > 0) {

        this.searchObject.networkId = coverageType[0].networkId;
        if (coverageType[0].altDestinationUrl) {
          this.searchObject.altDestinationUrl = coverageType[0].altDestinationUrl;
        }
        if (coverageType[0].externalNetworks) {
          this.countyData.counties = coverageType[0].externalNetworks;
          let i = 0;
          this.countyData.counties.forEach(e => {
            e.label = `${e.county}, ${e.state}`;
            e.value = i.toString();
            i++;
          });
        }
        this.coverageTypeValue = this.searchObject.networkId;
        this.notificationText = coverageType[0].notificationText;
        this.shouldDisplayPlanYearPicker = coverageType[0].shouldDisplayPlanYearPicker;
        this.searchObject.isServiceAreaSearch = coverageType[0].isServiceAreaSearch;
        this.searchObject.coverageType = coverageType[0].name;
        this.searchObject.isMultiSpecialtySearch = coverageType[0].isMultiSpecialtySearch;

        if (coverageType[0].shouldDisplayPlanYearPicker && coverageType[0].multiYearPlans?.length > 0) {
          this.multiYearPlans = coverageType[0].multiYearPlans;
        }

        if (coverageType[0].network) {
          if (coverageType[0].network.subProductKey && coverageType[0].network.displayKey) {
            this.searchObject.filters.subProductKey = coverageType[0].network.subProductKey;
            this.searchObject.filters.planDisplayKey = coverageType[0].network.displayKey;
          } else {
            this.searchObject.filters.subProductKey = undefined;
            this.searchObject.filters.planDisplayKey = undefined;
          }
        } else {
          this.searchObject.filters.subProductKey = undefined;
          this.searchObject.filters.planDisplayKey = undefined;
        }
      } 
    } else {
      this.coverageTypeValue = undefined;
    }
    this.searchObject.searchOption = SearchOptionTypes.specialty;
    this._formValidation('coverageType');
    this.networkIDChange$.next(null);
  }

  checkMultiYearPlan() {
    if (this.selectedMultiYearPlan) {
      this.searchObject.altDestinationUrl = this.selectedMultiYearPlan.altDestinationUrl ? this.selectedMultiYearPlan.altDestinationUrl : undefined;
      this.searchObject.searchYear = this.selectedMultiYearPlan.planYear ? this.selectedMultiYearPlan.planYear : undefined;
      this.searchObject.filters.subProductKey = this.selectedMultiYearPlan.subProductKey ? this.selectedMultiYearPlan.subProductKey : undefined;
      this.searchObject.filters.planDisplayKey = this.selectedMultiYearPlan.displayKey ? this.selectedMultiYearPlan.displayKey : undefined;
    } else {
      this.selectedMultiYearPlan.altDestinationUrl = undefined;
      this.searchObject.filters.subProductKey = undefined;
      this.searchObject.filters.planDisplayKey = undefined;
      this.searchObject.searchYear = undefined;
    }
  }

  updateRadius(event) {
    if (event.target.value) {
      this.searchObject.mileRadius = event.target.value;
    }
  }

  toggleAutoCompletePanel(evt, autoGroup): void {
    evt.stopPropagation();
    if (!autoGroup.isOpen) {
      this.specialtyOptions.data =  this.allSpecialties.data.slice();
      this.specialtyInputElement.nativeElement.focus();
      this.specialtyInput.openPanel();
    } else {
      this.specialtyInput.closePanel();
    }
  }

  // Specialty Handlers

  // HTML specialty handlers

  onKeyupAutoCompeteEvent(event) {
    if (event.keyCode !== 37 && event.keyCode !== 38 && event.keyCode !== 39 && event.keyCode !== 40 && event.keyCode !== 13) {
      const value = event.target.value;
      this.autoCompleteFormControl.setValue(value);
      this.searchObject.userInput = value;
      const _len = this.specialtyOptions.data.length;
      this.error.specialtyOptionsMsg = '';
      if (event.target.value) {
        this.hidePopular = true;
      } else {
        this.hidePopular = false;
      }
      if (_len === 0) {
        this.error.specialtyOptionsMsg = value.trim() === '' ? 'Please enter a provider type, specialty, service, or equipment.' : 'There is no provider type, specialty, service, or equipment that matches "' + value + '". Please try a different word.';
      }
    }
  }

  onChangeAutoCompeteEvent(event) {
    setTimeout(() => {
      const activeElement = document.activeElement;
      const inputs = ['span'];
      const value = event.target.value;
      let target = event.relatedTarget;

      // fix for IE blur
      if (target === null) {
        if (activeElement && inputs.indexOf(activeElement.tagName.toLowerCase()) !== -1 && activeElement.className === 'mat-option-text') {
          target = activeElement;
        }
      }

      if (!target) {
        this.onChangeAutoCompleteValue({ isUserInput: true }, value, '', false);
      }
    }, 500);
  }

  onChangeAutoCompleteValue(_event, value, type, fromOption) {
    let isValidValue = false;
    let objArr = [];
    let userInput = value;
    let specialtyType = type;
    if (_event.isUserInput) {
      if (!fromOption) {
        objArr = this.allSpecialties.data.filter(obj => obj.name.toLowerCase() === value.toLowerCase());
        if (this.specialtyOptions.data && objArr.length > 0) {
          isValidValue = true;
          userInput = objArr[0].name;
          specialtyType = objArr[0].type;
        }
      }

      if (!fromOption && !isValidValue) {
        this.hidePopular = false;
        this.specialtyOptions.data = this.allSpecialties.data.slice();
        this.error.specialtyOptionsMsg = value.trim() === '' ? 'Please enter a provider type, specialty, service, or equipment.' : 'There is no provider type, specialty, service, or equipment that matches "' + value + '". Please try a different word.';
      } else {
        this.searchObject.service = false;
        this.searchObject.specialty = null;
        this.searchObject.providerType = null;
        this.searchObject.userInput = userInput;
        this.searchObject.specialtyType = specialtyType;
        if (specialtyType === SpecialtyTypes.ProviderType) {
          this.searchObject.providerType = userInput;
        } else {
          if (specialtyType === SpecialtyTypes.Service) {
            this.searchObject.service = true;
          }
          this.searchObject.specialty = userInput;
        }
        this.hidePopular = false;
        this.specialtyOptions.data = this.allSpecialties.data.slice();
        this._formValidation('specialtyOptions');
      }
    }
  }

  onSearchOptionChanged() {
    this.searchObject.phoneNumber = null;
    this.searchObject.providerName = null;
    this.searchObject.specialty = null;
  }

  onSpecialtyChkChanged() {
    this.searchObject.specialty = null;
    this.searchObject.specialtyType = null;

    const specialty = this.chkboxSpecialties.filter(obj => obj.checked).map(obj => obj.name).join('|');
    if (!specialty) {
      this.searchObject.specialty = null;
      this.searchObject.userInput = null;
    } else {
      this.searchObject.specialty = specialty;
      this.searchObject.userInput = specialty;
    }
  }

  onSpecialtyInputFocus(id) {
    // if less than desktop width, scroll input to top
    if (window.screen.width < 1024) {
      const e = document.getElementById(id);
      e.scrollIntoView({behavior: 'smooth', block: 'start', inline: 'nearest'});
    }
  }

  // Return array of values that contain string/filter specialty list
  private _filter(name: string): any[] {
    let _groupFilters = [];
    if (name) {
      const filterValue = name.toLowerCase();

      const _filterData = this.allSpecialties.data.filter(option =>
        option.name.toLowerCase().includes(filterValue)
      );

      _groupFilters = _filterData;
    }

    return _groupFilters;
  }

  sortOrderSpecialties() {
    this.allSpecialties.data.sort(function (a, b) {
      const valueA = a.name.toLowerCase(), valueB = b.name.toLowerCase();
      if (valueA < valueB) { // sort string ascending
        return -1;
      } else if (valueA > valueB) {
        return 1;
      } else {
        return 0;
      } // default return value (no sorting)
    });

    this.popularSpecialties.data.sort(function (a, b) {
      if (a.orderNumber < b.orderNumber) {
        // sort string ascending
        return -1;
      } else if (a.orderNumber > b.orderNumber) {
        return 1;
      } else {
        return 0;
      } // default return value (no sorting)
    });
    // }
    this.specialtyOptions.data = this.autoCompleteFormControl.value ? this._filter(this.autoCompleteFormControl.value) : this.allSpecialties.data.slice();
  }

  addSpecialtiesData(data) {
    const _popularData = [];
    const _allData = [];
    const _values = [];
    data.forEach(element => {
      _values.push(element.name);
      _allData.push({
        name: element.name,
        type: element.type,
        isPopular: false,
        orderNumber: 0
      });
      if (element.isPopular) {
        _popularData.push({
          name: element.name,
          type: element.type,
          isPopular: element.isPopular,
          orderNumber: element.orderNumber
        });
      }
    });
    if (_popularData.length !== 0) {
      this.popularSpecialties.data = _popularData;
    }

    if (_allData.length !== 0) {
      this.allSpecialties.data = _allData;
    }

    if (_values.indexOf(this.searchObject.userInput) >= 0 || _values.indexOf(this.searchObject.providerType) >= 0 || _values.indexOf(this.searchObject.specialty) >= 0) {
      this.autoCompleteFormControl.setValue(this.searchObject.userInput);
    } else {
      this.autoCompleteFormControl.setValue('');
      this.searchObject.specialty = '';
      this.searchObject.userInput = '';
    }
  }

  addSpecialtiesCheckbox(data) {
    this.chkboxSpecialties = [];
    const checkedArr = this.searchObject.userInput ? this.searchObject.userInput.split('|') : [];
    data.forEach(e => {
      const checked = checkedArr.some(obj => obj.toLowerCase() === e.name.toLowerCase());
      checked ? e.checked = true : e.checked = false;
      this.chkboxSpecialties.push(e);
    });
    this.onSpecialtyChkChanged();
  }

  getSpecialties() {
    if (this.searchObject.networkId) {
      this.error.specialtyOptionsMsg = '';
      this.specialtyOptions.data = [];
      this.popularSpecialties.data = [];
      this.allSpecialties.data = [];
      this.specialtySub$.next(null);
    }
  }

  updateSpecialties(data) {
    if (data.specialties && data.specialties.length !== 0) {
      if (this.searchObject.isMultiSpecialtySearch) {
        this.addSpecialtiesCheckbox(data.specialties);
      } else {
        this.addSpecialtiesData(data.specialties);
        this.sortOrderSpecialties();
      }
    }
  }

  changeZipCode() {
    this.error.zipCodeMsg = '';
    this.searchObject.placeObject = null;
    this.searchObject.lat = null;
    this.searchObject.long = null;
    this.searchObject.zipCode = null;
    this.searchObject.county = null;
    this.searchObject.state = null;
    this._formValidation('address');
    this.isDisabledSearchBtn();
  }

  isDisabledSearchBtn(): boolean {
    let isDisabled = false;
    this.error.phoneNumberMsg = '';
    if (this.searchObject.searchOption && !this.searchObject.networkId) {
      isDisabled = true;
    }

    if (this.searchObject.searchOption === SearchOptionTypes.providerName && !this.searchObject.providerName) {
      isDisabled = true;
    }
    if (this.searchObject.searchOption === SearchOptionTypes.phoneNumber && this.searchObject.phoneNumber && (this.searchObject.phoneNumber.replace(/\D/g, '')).length > 10) {
      this.searchObject.phoneNumber = (this.searchObject.phoneNumber.replace(/\D/g, '').substring(0, 10)).replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2 - $3');
    }

    if (this.searchObject.searchOption === SearchOptionTypes.specialty) {
      if (this.searchObject.isMultiSpecialtySearch) {
        if (!this.searchObject.specialty) {
          isDisabled = true;
        }
      } else {
        if (!this.searchObject.userInput) {
          isDisabled = true;
        } else if (this.searchObject.userInput) {
          let isValidValue = false;
          isValidValue = this.allSpecialties.data.some(obj => obj.name.toLowerCase() === this.searchObject.userInput.toLowerCase());
          if (!isValidValue) {
            isDisabled = true;
          }
        }
      }
    } else if (this.searchObject.searchOption === SearchOptionTypes.phoneNumber && (!this.searchObject.phoneNumber || this.searchObject.phoneNumber?.replace(/\D/g, '').length !== 10)) {
      isDisabled = true;
    }

    if (!this.searchObject.address || !this.searchObject.county || !this.searchObject.state) {
      isDisabled = true;
    }

    return isDisabled;
  }

  submitSearchBtn(event) {
    if (event) {
      if (event.target.value) {
        if (this.searchObject.address === event.target.value) {
          this.submitSearch(false);
        } else {
          this.searchObject.address = event.target.value;
        }
      }
    }
  }

  submitPCPSearchBtn(event) {
    if (event) {
      if (event.target.value) {
        if (this.searchObject.address === event.target.value) {
          this.submitSearch(true);
        } else {
          this.searchObject.address = event.target.value;
        }
      }
    }
  }

  submitSearch(pcp) {
    if (this.specialtyInput && !this.specialtyInput.autocomplete._isOpen && this.searchObject.searchOption !== SearchOptionTypes.providerName) {
      if (this.searchObject.address) {
      this.submit(pcp);
      }
    } else {
      this.submit(pcp);
    }
    this.hidePopular = false;
  }
  submit(pcp) {
    this.searchObject.oldMileRadius = null;
    if (pcp) {
      if (this._formValidation('address')) {
        //this.GAService.pushSearchFormData(this.searchObject);
        this.searchObjectService.setSearchObject(this.searchObject);
        this.searchObjectService.setSearchURL(false, this.isLoginPage);
      }
    } else {
      if (this._formValidation('all')) {
        //this.GAService.pushSearchFormData(this.searchObject);
        this.searchObjectService.setSearchObject(this.searchObject);
        this.searchObjectService.setSearchURL(false, this.isLoginPage, true);
      }
    }
  }

  resetSearchForm() {
    this.error.specialtyOptionsMsg = '';
    this.resetSpecialtyProviderType();
  }

}

